import React from "react";
import { injectIntl } from "react-intl"
import { BaseDonut } from ".";
import { getEpoch } from "_metronic/_helpers";

export interface BradenMonitoringsDonutData {
  active: number
  total: number
}
export interface BradenMonitoringsDonutProps {
  intl: any
  data?: BradenMonitoringsDonutData
  width?: number
  height?: number
}
function BradenMonitoringsDonut(props: BradenMonitoringsDonutProps) {
  const { intl, data, width, height } = props
  const [newSignal, setNewSignal] = React.useState<number>(0)
  
  const [labels] = React.useState<Array<string>>([
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.EMPTY" }),
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.VERY_LOW" }),
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.LOW" }),
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.MEDIUM" }),
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.HIGH" }),
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.VERY_HIGH" }),
  ])
  const [colors] = React.useState<Array<string>>([
    '#b3b3b3d9',
    '#19f6fed9',
    '#93fe19d9',
    '#effe19d9',
    '#fe7519d9',
    '#fe1919d9'
  ])

  const onDataSerie = () => {
    // if (!data) return null
    return [
      10, 20, 30, 40, 50, 60
    ]
  }

  React.useEffect(() => {
    setNewSignal(getEpoch())
  }, [data])

  return (
    <BaseDonut
      width={width ?? '100%'} 
      height={height ?? '100%'}
      id='braden-monitorings'
      title={intl.formatMessage({id: "REPORTS.BRADEN.RANGE.TITLE"})}
      colors={colors}
      labels={labels}
      onDataSerie={onDataSerie}
      newDataSignal={newSignal}
      />
  )
}
export default injectIntl((BradenMonitoringsDonut))
